<template>
    <div>
        <div class="mb-2">
            <label class="col-3 text-bold px-0" for="record">異動紀錄：</label>
        </div>
        <div>
            <table class="table datatable">
                <thead>
                    <tr>
                        <th style="width:10%" class="text-center">序號</th>
                        <th style="width:20%" class="text-center">異動日期</th>
                        <th style="width:20%" class="text-center">異動人員</th>
                        <th style="width:50%" class="text-center">異動原因</th>
                    </tr>
                </thead>
                <tbody v-if="data">
                    <tr v-for="(item, i) in data" :key="`record-${i}`">
                        <td class="text-center">
                            {{ i+1 }}
                        </td>
                        <td class="text-center">
                            {{ item.createtimestamp | ymdsDateFormat}}
                        </td>
                        <td v-if="item.creatorname" class="text-center">
                            {{ item.creatorname | getMaskName }}
                        </td>
                        <td v-else class="text-center">
                            {{ item.creator | getMaskID }}
                        </td>
                        <td>
                            {{ item.modification_reason }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "RecordDataTable",
    props: {
        data: { 
            type: Array, 
            required: true, 
            default: () => []
        },
    },
    data() {
        return {};
    },
};
</script>